module.exports = __webpack_public_path__ + "static/media/ic-enforced.08f48817.svg";